module.exports = __webpack_public_path__ + "img/Процедурный кабинет.5305824f.jpg";